import { Chart, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend, ScatterController } from 'chart.js';


Chart.register(LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend, ScatterController);


// small custom crosshair plugin
export const customCrosshairPlugin = {
id: 'customCrosshair',
afterEvent: (chart, args) => {
const e = args.event;
if (e.type === 'mousemove') chart.customCrosshair = { x: e.x, y: e.y };
if (e.type === 'mouseout') chart.customCrosshair = null;
},
afterDraw: (chart) => {
if (!chart.customCrosshair) return;
const { x, y } = chart.customCrosshair;
const ctx = chart.ctx;
const topY = chart.scales?.y?.top ?? 0;
const bottomY = chart.scales?.y?.bottom ?? chart.height;
const leftX = chart.scales?.x?.left ?? 0;
const rightX = chart.scales?.x?.right ?? chart.width;
ctx.save();
ctx.beginPath();
ctx.setLineDash([5, 5]);
ctx.moveTo(x, topY);
ctx.lineTo(x, bottomY);
ctx.moveTo(leftX, y);
ctx.lineTo(rightX, y);
ctx.lineWidth = 1;
ctx.strokeStyle = 'rgba(0,0,0,0.5)';
ctx.stroke();
ctx.restore();
},
};


Chart.register(customCrosshairPlugin);